export default {
	methods: {
		compareDates(a, b) {
			if (a.getFullYear() == b.getFullYear() && a.getMonth() == b.getMonth() && a.getDate() == b.getDate()) {
				return 0;
			}

			return a.getTime() < b.getTime() ? -1 : 1;
		},
		compareMonths(a, b) {
			if (a.getYear() == b.getYear() && a.getMonth() == b.getMonth()) {
				return 0;
			}

			return a.getTime() < b.getTime() ? -1 : 1;
		}
	}
}